import { useTranslation } from "react-i18next";

export const useGetTitle = (title?: string, serviceId?: number) => {
  const { t } = useTranslation();

  const truncate = (str: string) =>
    str.length > 24 ? `${str.substring(0, 25)}...` : str;

  return title ? truncate(title) : t("layout.tiles.activeSim.yourDevice");
};
